module.exports = __webpack_public_path__ + "img/bench-footer.2276a86d.jpg";